import useCreate from "@/hooks/use-create";
import { UseLoadingReturn } from "@/hooks/use-loading";
import { IKitComponentInput } from "@/interfaces/kit.interface";
import kitService from "@/services/kit.service";
import { RequestsProps } from "@/types/requests.types";

export type CreateKitProps = {
  formData: IKitComponentInput;
} & RequestsProps;

export type UseCreateKitReturn = {
  create: (props: CreateKitProps) => Promise<void>;
} & UseLoadingReturn;

const useCreateKit = (): UseCreateKitReturn => {
  const { isLoading, startLoading, endLoading, loadingIcon, create } =
    useCreate<IKitComponentInput>({
      operation: (formData) => kitService.create(formData),
    });

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    create,
  };
};

export default useCreateKit;
